import { render, staticRenderFns } from "./task-form.vue?vue&type=template&id=41e645f4&scoped=true"
import script from "./task-form.vue?vue&type=script&lang=js"
export * from "./task-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e645f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41e645f4')) {
      api.createRecord('41e645f4', component.options)
    } else {
      api.reload('41e645f4', component.options)
    }
    module.hot.accept("./task-form.vue?vue&type=template&id=41e645f4&scoped=true", function () {
      api.rerender('41e645f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/setting/task/components/task-form.vue"
export default component.exports